<template>
  <VMenu :triggers="['hover', 'focus']">
    <a><HelpCircle /></a>

    <template #popper>
      {{ content }}
    </template>
  </VMenu>
</template>

<script>
import HelpCircle from "../assets/help-circle.svg";

export default {
  name: "Tooltip",
  components: { HelpCircle },
  props: ["sendAnalytics", "content"],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
